import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { useSEO } from "@/lib/useSEO";
import InstagramFeed from "@/components/InstagramFeed";
import { Instagram, ArrowRight } from "lucide-react";

export default function Social() {
  useSEO({
    title: "Social — @flow_state_method | Better Through Boxing",
    description: "Follow Coach Chris Persaud and the Better Through Boxing community on Instagram. Training clips, fundamentals breakdowns, community meetup recaps, and behind-the-scenes from The Flow State Method LLC.",
    path: "/social",
    keywords: ["flow state method instagram", "coach chris persaud boxing", "better through boxing community", "boxing training videos", "boxing fundamentals"],
  });

  return (
    <div className="App relative">
      <SiteHeader />
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24" data-testid="social-page">
        {/* Hero — SEO-rich, always rendered */}
        <header className="mb-12 max-w-3xl">
          <div className="text-[#FF331F] text-xs uppercase tracking-[0.3em] font-bold mb-3 flex items-center gap-2">
            <Instagram className="h-3 w-3" /> Social · The Flow State Method LLC
          </div>
          <h1 className="font-display font-bold uppercase text-5xl md:text-7xl tracking-tight leading-none mb-6">In the<br />flow.</h1>
          <p className="text-zinc-300 text-base md:text-lg leading-relaxed mb-4">
            A live, curated feed from <a href="https://www.instagram.com/flow_state_method/" target="_blank" rel="noreferrer" className="text-[#FF331F] hover:underline">@flow_state_method</a> on Instagram — training breakdowns, footwork drills, fundamentals clinics, community meetup recaps, and the occasional knockout moment from Coach Chris&apos;s work with private clients across the Better Through Boxing program.
          </p>
          <a href="https://www.instagram.com/flow_state_method/" target="_blank" rel="noreferrer" className="inline-flex items-center bg-[#FF331F] hover:bg-[#FF5242] text-white font-bold uppercase tracking-widest text-xs px-5 py-3 rounded-sm">
            <Instagram className="h-4 w-4 mr-2" /> Follow on Instagram <ArrowRight className="h-3 w-3 ml-2" />
          </a>
        </header>

        <InstagramFeed placement="social" limit={30} variant="grid" showHeader={false} />
      </main>
      <SiteFooter />
    </div>
  );
}
